/**
 * 复制重叠分析结果时剥离 `<dynamic_ui>` 信封（EDG-561 RK-14）：
 * 复制到剪贴板的应是可读的 Markdown，不该带 `<dynamic_ui …>{json}</dynamic_ui>` 这类渲染指令。
 *
 * 范围决策（manifest D-11）：只对**重叠结果消息**使用，其余消息的复制行为不动，
 * 避免改变现有所有图表消息的行为。
 */
export const stripDynamicUiEnvelopes = (markdown: string): string =>
  markdown
    .replace(/<dynamic_ui(?:\s+[^>]*)?>[\s\S]*?<\/dynamic_ui>/g, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
